/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
// import decode from 'jwt-decode';
import auth from '@/services/auth';
import Raven from 'raven-js';
import moment from 'moment-timezone';

import * as types from '../mutations/auth';

const state = {
  // status
  isAuthenticating: false,
  isSendingHeartbeat: false,
  isCheckingSession: false,
  isSubmittingPassword: false,
  // profile
  idToken: null,
  userId: null,
  userName: '',
  needResetPwd: false,
  tenantId: '',
  activeTimestamp: 0,
  // userRole: null,
};
const getters = {
  userId: state => state.userId,
  idToken: state => state.idToken,
  userName: state => state.userName,
  needResetPwd: state => state.needResetPwd,
  isAuthenticated: state => state.idToken !== null,
  tenantId: state => state.tenantId,
  activeTimestamp: state => state.activeTimestamp,
  // userRole: state => state.userRole,
  /* isAdminRole: state => state.userRole === 'admin',
  isViewerRole: state => state.userRole === 'viewer',
  isBillerRole: state => state.userRole === 'biller', */
};
const actions = {
  AUTH_CLEAR_STATE({ commit }) {
    return new Promise((resolve) => {
      commit(types.AUTH_STATE_CLEARED);
      resolve();
    });
  },
  LOGIN({ commit }, { tenant_id: tenantId, email, password }) {
    return new Promise((resolve, reject) => {
      commit(types.LOGIN_REQUEST);
      auth.login(tenantId, email, password, (err, result) => {
        if (err) {
          commit(types.LOGIN_FAIL);
          return reject(err);
        }
        result.email = email;
        commit(types.LOGIN_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  /* eslint no-else-return: 0 */
  LOGOUT({ state, commit }, { vm }) {
    const token = JSON.parse(JSON.stringify(state.idToken));
    return new Promise((resolve, reject) => {
      commit(types.LOGOUT_SUCCESS);
      vm.$nextTick(() => {
        vm.$store.dispatch('APP_CLEAR_STATE');
        vm.$store.dispatch('AUTH_CLEAR_STATE');
        vm.$store.dispatch('BILLER_CLEAR_STATE');
        vm.$store.dispatch('COMPANY_CLEAR_STATE');
        if (token) {
          // we simply clear auth stuff
          return auth.logout(token, (err) => {
            if (err) {
              return reject(err);
            }
            // now we wipe out the storage for vux
            return resolve();
          });
        } else {
          return resolve();
        }
      });
    });
  },
  SEND_HEARTBEAT({ state, commit }) {
    const token = state.idToken;
    return new Promise((resolve, reject) => {
      // check if we is sending heartbeat in any tab or not
      if (state.isSendingHeartbeat) {
        resolve();
      } else {
        commit(types.HEARTBEAT_REQUEST);
        auth.heartbeat(token, (err, result) => {
          if (err) {
            commit(types.HEARTBEAT_FAIL);
            return reject(err);
          }
          commit(types.HEARTBEAT_SUCCESS, result);
          return resolve(result);
        });
      }
    });
  },
  UPDATE_ACTIVE_TIMESTAMP({ commit }) {
    return new Promise((resolve) => {
      const now = moment().tz(process.env.DEFAULT_TZ);
      commit(types.ACTIVE_TIMESTAMP_UPDATED, Number(now.format('X')));
      return resolve();
    });
  },
  CHECK_SESSION({ state, commit }) {
    const token = state.idToken;
    console.log('CHECK_SESSION', token);
    return new Promise((resolve, reject) => {
      // check if we is sending check session in any tab or not
      /* if (state.isCheckingSession) {
        resolve();
      } else */
      if (token === null) {
        commit(types.HEARTBEAT_FAIL);
        reject();
      } else {
        commit(types.CHECK_SESSION_REQUEST);
        auth.checkSession(token, (err, result) => {
          console.log('check session', err, result);
          if (err) {
            commit(types.HEARTBEAT_FAIL);
            return reject(err);
          }
          commit(types.HEARTBEAT_SUCCESS, result);
          return resolve(result);
        });
      }
    });
  },
  CHANGE_PASSWORD({ commit }, { force, token, password }) {
    return new Promise((resolve, reject) => {
      commit(types.CHANGE_PASSWORD_REQUEST);
      auth.changePassword(force, token, password, (err, result) => {
        if (err) {
          commit(types.CHANGE_PASSWORD_FAIL);
          return reject(err);
        }
        commit(types.CHANGE_PASSWORD_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  RESET_PASSWORD({ commit }, { tenantId, email }) {
    return new Promise((resolve, reject) => {
      commit(types.RESET_PASSWORD_REQUEST);
      auth.resetPassword(tenantId, email, (err, result) => {
        if (err) {
          commit(types.RESET_PASSWORD_FAIL);
          return reject(err);
        }
        commit(types.RESET_PASSWORD_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SET_TENANT_ID({ commit }, slug) {
    return new Promise((resolve) => {
      const tenantId = slug === 'admin' ? 'scb' : slug;
      commit(types.TENANT_ID_SET, tenantId);
      resolve();
    });
  },
  /* FORCE_LOGIN({ commit }) {
    commit(types.FORCE_LOGIN);
  },
  FORCE_LOGOUT({ commit }) {
    commit(types.FORCE_LOGOUT);
  }, */
};
const mutations = {
  [types.LOGIN_REQUEST](state) {
    state.isAuthenticating = true;
  },
  [types.LOGIN_FAIL](state) {
    state.isAuthenticating = false;
  },
  [types.LOGIN_SUCCESS](state, {
    token,
    user_id: userId,
    user_name: userName,
    need_reset_pwd: needResetPwd,
    email,
    // role,
  }) {
    state.isAuthenticating = false;
    state.idToken = token;
    state.userId = userId;
    state.userName = userName;
    state.needResetPwd = needResetPwd;
    // state.userRole = role;
    // log sentry
    Raven.setUserContext({
      userId,
      email,
      userName,
    });
  },
  [types.LOGOUT_SUCCESS](state) {
    state.isAuthenticating = false;
    state.idToken = null;
    state.userId = null;
    state.userName = '';
    state.needResetPwd = false;
    // state.userRole = null;
    Raven.setUserContext();
  },
  [types.HEARTBEAT_REQUEST](state) {
    state.isSendingHeartbeat = true;
  },
  [types.CHECK_SESSION_REQUEST](state) {
    state.isCheckingSession = true;
  },
  [types.HEARTBEAT_FAIL](state) {
    state.isSendingHeartbeat = false;
    state.isCheckingSession = false;
  },
  [types.HEARTBEAT_SUCCESS](state) {
    state.isSendingHeartbeat = false;
    state.isCheckingSession = false;
  },
  [types.TENANT_ID_SET](state, slug) {
    state.tenantId = slug;
  },
  /* [types.REFRESH_TOKEN_SUCCESS](state) {
    state.isAuthenticating = false;
  }, */
  /* [types.FORCE_LOGIN](state) {
    state.idToken = 'test';
  },
  [types.FORCE_LOGOUT](state) {
    state.idToken = null;
  }, */
  [types.RESET_PASSWORD_REQUEST](state) {
    state.isSubmittingPassword = true;
  },
  [types.RESET_PASSWORD_SUCCESS](state) {
    state.isSubmittingPassword = false;
  },
  [types.RESET_PASSWORD_FAIL](state) {
    state.isSubmittingPassword = false;
  },
  [types.CHANGE_PASSWORD_REQUEST](state) {
    state.isSubmittingPassword = true;
  },
  [types.CHANGE_PASSWORD_SUCCESS](state) {
    state.isSubmittingPassword = false;
    state.needResetPwd = false;
  },
  [types.CHANGE_PASSWORD_FAIL](state) {
    state.isSubmittingPassword = false;
  },
  [types.AUTH_STATE_CLEARED](state) {
    state.isAuthenticating = false;
    state.isSendingHeartbeat = false;
    state.isCheckingSession = false;
    state.isSubmittingPassword = false;
    state.idToken = null;
    state.userId = null;
    state.userName = '';
    state.needResetPwd = false;
  },
  [types.ACTIVE_TIMESTAMP_UPDATED](state, nowTimestamp) {
    state.activeTimestamp = nowTimestamp;
  },
};

/**
 * Auth Store - Manage Authentication state
 */
const AuthStore = {
  state,
  getters,
  actions,
  mutations,
};

export default AuthStore;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js